import { storeToRefs } from 'pinia'
import { useCommonData } from '@/stores/commom'

export default class Singlestore {
  static selef: Singlestore
  public isSinglestore: boolean
  public isTakeoutMiniProgram: boolean
  private _defaultShopId: number
  private _optionsId?: number

  constructor() {
    const { nowAppid, singlestoreWeixinAppid, takeoutMiniProgramAppid } = storeToRefs(
      useCommonData(),
    )
    this.isSinglestore = nowAppid.value === singlestoreWeixinAppid.value
    this.isTakeoutMiniProgram = nowAppid.value === takeoutMiniProgramAppid.value
    this._defaultShopId = import.meta.env.VITE_ENV === 'dev' ? 590 : 1716
    Singlestore.selef = this
  }

  setShopId(options?: AnyObject) {
    console.log(options, '参数')
    let shopId = this._defaultShopId
    if (options) {
      // 正常进入
      if (options.id) {
        shopId = options.id
        this._optionsId = options.id
      }
      // 扫码进入
      if (options.scene) {
        uni.setStorageSync('singlestoreId', options.scene)
      }
    }
    const storeTempId = uni.getStorageSync('singlestoreId')
    return storeTempId ? storeTempId : shopId
  }

  getShopId() {
    const id = uni.getStorageSync('singlestoreId') || this._optionsId || this._defaultShopId
    return id
  }
}
